exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "thead[data-v-f01f6568] {\n  color: #999999;\n}\nthead th[data-v-f01f6568] {\n  border-top: 0;\n}\n.sau-dynamic-table select[data-v-f01f6568] {\n  background: none;\n  color: #00ce7d;\n  /* browser resets */\n  margin: 0;\n  box-sizing: border-box;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  /* custom arrow */\n  background: #fff url(\"/img/chevron-down-success.svg\") no-repeat;\n  background-size: 20px;\n  background-position: right center;\n  padding-right: 30px;\n}", ""]);

// exports
